if (!customElements.get('social-proof-pulse')) {
  customElements.define(
    'social-proof-pulse',
    class SocialProofPulse extends HTMLElement {
      connectedCallback() {
        try {
          this.textElement = this.querySelector('.social-proof__text');
          this.baseCount = this.seededCount();
          this.currentCount = this.baseCount;
          this.render();
          this.interval = window.setInterval(() => {
            const drift = Math.floor(Math.random() * 5) - 2;
            this.currentCount = Math.min(47, Math.max(3, this.baseCount + drift));
            this.render();
          }, 60000);
        } catch (error) {
          console.error(error);
        }
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      seededCount() {
        const productId = Number(this.dataset.productId || 0);
        const hour = new Date().getHours();
        return ((productId * 7 + hour * 13) % 45) + 3;
      }

      render() {
        if (!this.textElement) return;
        this.hiddenMobile = this.currentCount < 5 ? 'true' : 'false';
        this.setAttribute('hidden-mobile', this.hiddenMobile);
        this.textElement.textContent = this.dataset.template.replace('__count__', this.currentCount);
      }
    }
  );
}
